module.exports = __webpack_public_path__ + "media/images/shark/Josh-p-800-ce60bbacb382146f959fdccf1e629e51.jpeg";